/* eslint-disable */
const getters = {
  getCustomer(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
